// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"visit_wrapper__s1V1Q","tableWrapper":"visit_tableWrapper__1o5T0"};